import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import store from 'store/Store';
import Actions from 'actions/Actions';
import getModal from 'services/api/cms/getModal';
import {
    Grid, Box, Text, Icon
} from 'components/ui';
import InfoButton from 'components/InfoButton/InfoButton';
import TopContentLayout from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/TopContentLayout';
import { isBundleApplied } from 'utils/RewardBundle';
import localeUtils from 'utils/LanguageLocale';
import RewardBundlingAwarenessMessageEN from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/locales/RewardBundlingAwarenessMessage_en_US';
import RewardBundlingAwarenessMessageFR from 'components/RwdBasket/RwdBasketLayout/TopContentMessages/locales/RewardBundlingAwarenessMessage_fr_CA';

const REWARD_BUNDLING_MODAL_SID = 'Reward_Bundling_Modal';
const REWARD_BI_TYPE = '100 Points';
const MIN_REWARD_COUNT = 3;

const getText = localeUtils.getLocalisedDataFromResource(RewardBundlingAwarenessMessageEN, RewardBundlingAwarenessMessageFR);

function countRewardsInItems(items) {
    if (!Array.isArray(items)) {
        return 0;
    }

    return items.filter(item => item?.sku?.biType === REWARD_BI_TYPE).length;
}

async function handleInfoTap() {
    const { country, channel, language } = Sephora.renderQueryParams || {};

    try {
        const modalContent = await getModal({
            country,
            channel,
            language,
            sid: REWARD_BUNDLING_MODAL_SID
        });

        store.dispatch(
            Actions.showContentModal({
                isOpen: true,
                data: {
                    sid: REWARD_BUNDLING_MODAL_SID,
                    title: modalContent?.title,
                    body: modalContent?.body
                }
            })
        );
    } catch (error) {
        Sephora.logger.error('RewardBundling: Terms modal fetch failed', error);
    }
}

function RewardBundlingAwarenessMessage({
    isSignedIn, isEnabled, items, basketRoot, isBopisBasket
}) {
    if (!isSignedIn) {
        return null;
    }

    if (!isEnabled) {
        return null;
    }

    if (countRewardsInItems(items) < MIN_REWARD_COUNT) {
        return null;
    }

    if (!isBopisBasket && isBundleApplied(basketRoot)) {
        return null;
    }

    return (
        <TopContentLayout>
            <Grid
                data-testid='reward-bundling-awareness-message'
                columns='auto 1fr auto'
                gap={3}
                lineHeight='tight'
                alignItems='center'
            >
                <Box alignContent='center'>
                    <Icon
                        name='rewardBazaar'
                        size={20}
                    />
                </Box>
                <Box alignContent='center'>
                    <Text fontSize='sm'>{getText('awarenessTitle')}</Text>
                </Box>
                <InfoButton
                    aria-label={getText('infoIconLabel')}
                    onClick={handleInfoTap}
                />
            </Grid>
        </TopContentLayout>
    );
}

export default wrapFunctionalComponent(RewardBundlingAwarenessMessage, 'RewardBundlingAwarenessMessage');
